import React, { PropsWithChildren } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardContentProps,
} from '@mui/material';
import { SidebarMenu } from '@features/workspace/components/layouts/sidebar-menu';
import { resolvePageMeta } from '@app/services/pages-meta';
import { makeStyles } from 'tss-react/mui';
import { CardProps } from '@mui/material/Card/Card';
import { LayoutType } from '../const';
import PageHeader from './page-header';

const useStyles = makeStyles<any>()({
  container: {
    display: 'flex',
    minHeight: '100vh',
  },
  sidebar: {
    display: 'flex',
    background: '#0F253B',
    paddingRight: '20px',
    flexShrink: 1,
  },
  content: {
    position: 'relative',
    background: '#F5F6FA',
    borderTopLeftRadius: '20px',
    borderBottomLeftRadius: '20px',
    marginLeft: '-20px',
    padding: '52px',
  },
  // TODO: define appropriate variant instead once theme covers it
  pageTitle: {
    color: '#4B4B4B !important',
  },
});

export const LayoutCard = ({
  children,
  cardContentProps,
  ...props
}: PropsWithChildren<CardProps & { cardContentProps?: CardContentProps }>) => (
  <Card {...props} sx={{ width: '100%', ...(props.sx ?? {}) }}>
    <CardContent
      {...(cardContentProps ?? {})}
      sx={{ paddingTop: '40px', ...(cardContentProps?.sx ?? {}) }}
    >
      {children}
    </CardContent>
  </Card>
);

interface IProps {
  layoutType?: LayoutType;
  hasHeader?: boolean;
}

export default function Layout({
  children,
  layoutType = LayoutType.CUSTOMER,
  hasHeader = true,
}: PropsWithChildren<IProps>): JSX.Element {
  const { classes } = useStyles(null);

  const pageMeta = resolvePageMeta();

  // const hasRootPageHeader = pagesMeta
  //     .reduce((acc, meta: any) => {
  //         acc ||= meta.uri.includes(location.pathname.replace(/\/$/g, ''))
  //         if (meta.hasLayoutHeaderRegex) {
  //             acc ||= location.pathname.match(meta.hasLayoutHeaderRegex) !== null
  //         }
  //         return acc
  //     }, false)

  return (
    <Box className={classes.container}>
      <Box className={classes.sidebar}>
        <SidebarMenu pageMeta={pageMeta} />
      </Box>
      <Box
        className={classes.content}
        display="flex"
        flexDirection="column"
        flexGrow={1}
      >
        {hasHeader && (
          <>
            <Box alignItems="center" display="flex" mb={4}>
              <Box display="flex">{pageMeta?.headerIcon}</Box>
              <Box display="flex" flexGrow={1} ml={1}>
                <Typography className={classes.pageTitle} variant="h5">
                  {pageMeta?.headerTitle}
                </Typography>
              </Box>
            </Box>
            <Box mb={4}>
              <PageHeader layoutType={layoutType} />
            </Box>
          </>
        )}
        {children}
      </Box>
    </Box>
  );
}
